import { render, staticRenderFns } from "./DepositSummary.vue?vue&type=template&id=0403c65b&scoped=true&"
import script from "./DepositSummary.vue?vue&type=script&lang=js&"
export * from "./DepositSummary.vue?vue&type=script&lang=js&"
import style0 from "./DepositSummary.vue?vue&type=style&index=0&id=0403c65b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403c65b",
  null
  
)

export default component.exports